"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdminUpdateCommand = void 0;
const eventsUtils_1 = require("./eventsUtils");
const createAdminUpdateCommand = (aggregate) => ({
    versions: [
        {
            version: -1,
            validateCommand: async () => ([]),
            processCommand: (commandInstance) => {
                // Search through aggregate, find any properties that have a one_to_many relationship, and check if the incoming command modifies that property. If it does, create "add" and/or "remove" AdminUpdateEvents
                const oneToManyEventsMap = {};
                Object.keys(aggregate.properties).forEach((key) => {
                    const value = aggregate.properties[key];
                    if ('relation' in value && value.relation === 'ONE-TO-MANY') {
                        // Double check this is right...
                        if (key in commandInstance.data) {
                            commandInstance.data[key].added.forEach((addedId) => {
                                const localCommandInstance = Object.assign(Object.assign({}, commandInstance), { data: {
                                        [value.foreignColumn]: commandInstance.target,
                                    }, target: addedId });
                                oneToManyEventsMap[addedId] = {
                                    events: [
                                        ...(oneToManyEventsMap[addedId] ? oneToManyEventsMap[addedId].events : []),
                                        // Set the field and value
                                        (0, eventsUtils_1.buildEvent)({
                                            commandInstance: localCommandInstance,
                                            eventType: 'AdminUpdateEvent',
                                            eventVersion: -1,
                                            data: localCommandInstance.data,
                                            eventSchemaVersion: 1,
                                        }),
                                    ],
                                    aggregateType: value.type,
                                };
                            });
                            commandInstance.data[key].removed.forEach((removedId) => {
                                const localCommandInstance = Object.assign(Object.assign({}, commandInstance), { data: {
                                        [value.foreignColumn]: null,
                                    }, target: removedId });
                                oneToManyEventsMap[removedId] = {
                                    events: [
                                        ...(oneToManyEventsMap[removedId] ? oneToManyEventsMap[removedId].events : []),
                                        // Set the field and value
                                        (0, eventsUtils_1.buildEvent)({
                                            commandInstance: localCommandInstance,
                                            eventType: 'AdminUpdateEvent',
                                            eventVersion: -1,
                                            data: localCommandInstance.data,
                                            eventSchemaVersion: 1,
                                        }),
                                    ],
                                    aggregateType: value.type,
                                };
                            });
                        }
                    }
                });
                return Promise.resolve(Object.assign({ [commandInstance.target]: {
                        aggregateType: aggregate.typeName,
                        events: [
                            (0, eventsUtils_1.buildEvent)({
                                commandInstance,
                                eventType: 'AdminUpdateEvent',
                                eventVersion: -1,
                                data: commandInstance.data,
                                eventSchemaVersion: 1,
                            }),
                        ],
                    } }, oneToManyEventsMap));
            },
        },
    ],
});
exports.createAdminUpdateCommand = createAdminUpdateCommand;
//# sourceMappingURL=adminCommandUtils.js.map